<template>
  <div class="bottom">
    <div class="footer">
      <ul class="bottom_navs">
        <router-link to="Home" tag="li">首页</router-link>
        <router-link to="Technology_Services" tag="li">技术与服务</router-link>
        <router-link to="Big_Data" tag="li">大数据研究所</router-link>
        <router-link to="About_Us" tag="li">关于我们</router-link>
        <router-link to="Contact_Us" tag="li">联系我们</router-link>
      </ul>

      <p class="text">免费热线：（0512）65929315 QQ：1048789942 邮箱：service@raipeng.com</p>
      <p class="text">地址： 苏州市工业园区独墅湖崇文路创意产业园7栋8楼</p>
      <p class="text">Copyright © 2013-2019 www.raipeng.com All Rights Reserved 苏州瑞鹏信息技术有限公司版权所有 <a style="text-decoration: none;color:rgba(0,0,0,1)" target="_blank" href="https://beian.miit.gov.cn/">苏ICP备13034509号-2</a>
        苏B2-20130343</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .bottom {
    width: 100%;
    height: 200px;
    border-top: 1px solid #ccc;

    .footer {
      width: 1200px;
      height: 200px;
      margin: 0 auto;
      text-align: center;

      .bottom_navs {
        display: inline-block;
        margin: 36px auto;

        li {
          list-style: none;
          float: left;
          margin-right: 70px;
          height: 23px;
          line-height: 23px;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          cursor: pointer;

          &:hover {
            font-size: 28px;
            color: #4196FF;
          }
        }
      }
      .text {
        height:20px;
        font-size:16px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        margin: 0 0 13px;

        a:hover {
          color: #4196FF!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue